import isSvg from 'is-svg';
import isUrl from 'is-url';

const {
  blocks: { createBlock },
} = wp;

const transforms = {
  from: [
    {
      type: 'block',
      blocks: ['b3rg/svg-animator'],
      transform: (attributes) => {
        const updatedAttributes = {
          blockClassNames: attributes.blockClassNames,
          attachmentId: attributes.media.id ?? 0,
        };
        if (attributes.media.url) {
          if (isUrl(attributes.media.url)) {
            updatedAttributes.iconName = attributes.media.url;
            updatedAttributes.iconExtension = attributes.media.url
              .split('.')
              .pop();
          } else if (isSvg(attributes.media.url)) {
            updatedAttributes.icon = attributes.media.url;
          } else {
            updatedAttributes.iconName = attributes.media.url;
          }
        }
        return createBlock('b3rg/icon-block', updatedAttributes);
      },
    },
  ],
  to: [
    {
      type: 'block',
      blocks: ['b3rg/svg-animator'],
      transform: (attributes) => {
        const mediaUrl = () => {
          let output = '';
          if (isUrl(attributes.icon)) {
            output = attributes.icon;
          } else if (isUrl(attributes.iconName)) {
            output = attributes.iconName;
          } else {
            output = null;
          }
          return output;
        };
        return createBlock('b3rg/svg-animator', {
          blockClassNames: attributes.blockClassNames,
          media: { id: attributes.attachmentId ?? null, url: mediaUrl() },
        });
      },
    },
  ],
};

export default transforms;
